import React, { useState, useEffect } from "react";
// import { Tab, Tabs } from "@material-ui/core";
import styles from "./About.module.css";
import getAboutDetails from "../../services/request/about";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import ReactHtmlParser from "react-html-parser";

import "react-multi-carousel/lib/styles.css";
import { Grid, Paper, Tabs, Tab,makeStyles } from "@material-ui/core";

import Carousel from "react-multi-carousel";
import right from "../../assets/images/right.png";
import left from "../../assets/images/left.png"


export default function TabFctn() {
  const [value, setValue] = useState(0);
  const [teamList, setTeamList] = useState([])
  

useEffect(() => {
  const team = getAboutDetails();
  console.log(team)
  team.then((data) => {
    const sortedTeam = data.data.team.sort((a, b) => a.id - b.id);
    setTeamList(sortedTeam);
  });
}, []);
   
   
  useEffect(() => [teamList]);
  const handleTabs = (e, val) => {
    setValue(val);
  };

  const [selectedItem, setSelectedItem] = useState("");
  const [isInfoVisible, setIsInfoVisible] = useState({});
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop,setIsDesktop] = useState(false)

  useEffect(() => {
    const updateWindowDimensions = () => {
      const screenWidth = window.innerWidth;
      setIsMobile(screenWidth < 768);  
      setIsTablet(screenWidth >= 768 && screenWidth < 1024);  
      setIsDesktop(screenWidth >=1024);
    };

    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);

     
    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []); 


  const handleImageClick = (id) => {
    
    setIsInfoVisible((prevState) => ({
      ...prevState,
      [id]: !prevState[id] || false,
    }));
    setHoveredItem(id);
  };

  const handleMouseOver = (id) => {
    setSelectedItem(id);
  };

  const handleMouseOut = (id) => {
     
    setIsInfoVisible((prevState) => ({
      ...prevState,
      [id]: false,
    }));
    setSelectedItem("");
    setHoveredItem(null); 
  };
  const [zoomedIn, setZoomedIn] = useState(null);

  const handleImageClick1 = (id) => {
    setZoomedIn((prevZoomedIn) => (prevZoomedIn === id ? null : id)); 
  };

  const businessTeam = teamList
    ?.map((member) => {
      let { id, name, profilePicture, designation, text } = member;

      return (
        <div key={id} className={`${styles.teamCardroot} ${zoomedIn=== id ? styles.zoomedIn : ""}`}>
      <div
        onMouseOver={() => handleMouseOver(id)}
        className={`${styles.cardContainer} ${zoomedIn=== id   ? styles.zoomedIn : ""}`}
      >
        {profilePicture && (
          <img
            src={IMAGE_URL + profilePicture + SITE_ID}
            alt="sharzad"
            className={`${styles.image} `}
            onClick={() => {
              handleImageClick(id);
              handleImageClick1(id);
            }}
            loading="lazy"
            style={{ cursor: "pointer" }}
          />
        )}

        <div className={styles.heightofcontainer}>
          <h2 className={styles.name}>{name}</h2>
          <p className={styles.designation}>{designation}</p>
        </div>
      </div>
      {isInfoVisible[id] && (
        <div className={styles.tcInfo}>
          <p className={styles.Info}>{ReactHtmlParser(text)}</p>
        </div>
      )}
    </div>
      );
    });

  
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5,
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
      },
    };
  // Split businessTeam into two parts if there are more than 4 items
  const firstDivItems = businessTeam.slice(0, 4);
  const secondDivItems = businessTeam.slice(4);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
      backgroundColor:'#00000000',
      boxShadow:'none'
    },
  }));
  const classes = useStyles();

  const arrowStyle = {
     
    border: 0,
    // color: "red",
    // fontSize: "80px"
  };
  const CustomRight = ({ onClick }) => (
    <button className={`${styles.arrow}  ${styles.right}`} onClick={onClick} style={arrowStyle}>
     <img src={right} alt=">"/>
    </button>
  );
  const CustomLeft = ({ onClick }) => (
    <button className={`${styles.arrow}  ${styles.left}`} onClick={onClick} style={arrowStyle}>
      <img src={left} alt="f"/>
    </button>
  );

  return (
    <>
    {isMobile &&  
   <div>
   <div className={styles.tab}>
     <Tabs
       value={value}
       onChange={handleTabs}
       TabIndicatorProps={{
         style: {
           backgroundColor: "#caac7b",
           color: "#caac7b",
         },
       }}
     >
        
     </Tabs>
   </div>
   <TabPanel value={value} index={0}>
     <Carousel responsive={responsive} customRightArrow={<CustomRight />}
            customLeftArrow={<CustomLeft />} swipeable={true}
            draggable={true}>{businessTeam }</Carousel>
   </TabPanel>
   
 </div>

       
}
{isTablet &&  
   <div>
   <div className={styles.tab}>
     <Tabs
       value={value}
       onChange={handleTabs}
       TabIndicatorProps={{
         style: {
           backgroundColor: "#caac7b",
           color: "#caac7b",
         },
       }}
     >
        
     </Tabs>
   </div>
   <TabPanel value={value} index={0}>
     <Carousel responsive={responsive} customRightArrow={<CustomRight />}
            customLeftArrow={<CustomLeft />}  swipeable={true}
            draggable={true}>{businessTeam }</Carousel>
   </TabPanel>
   
 </div>

       
}
  {isDesktop &&
   <div className={classes.root}>
  <div className={styles.tab}>
     <Tabs
       value={value}
       onChange={handleTabs}
       TabIndicatorProps={{
         style: {
           backgroundColor: "#caac7b",
           color: "#caac7b",
         },
       }}
     >
        
     </Tabs>
   </div>
   <TabPanel value={value} index={0}>
     <Carousel responsive={responsive} customRightArrow={<CustomRight />}
            customLeftArrow={<CustomLeft />} swipeable={true}
            draggable={true} >{businessTeam }</Carousel>
   </TabPanel>
         </div>
  }
        </>
  );
}
function TabPanel(props) {
  const { children, value, index } = props;
  return <div>{value === index && <h1>{children}</h1>}</div>;
}

